module.exports = __webpack_public_path__ + "static/media/pencil04.7ad9a78d.webp";